import { SET_ORGANIZATION_AND_COLLECTION } from '@/store/mutation-types'

export default {
  [SET_ORGANIZATION_AND_COLLECTION] (state, { organizationId, collectionIndex }) {
    state.organizationId = organizationId
    state.collectionIndex = collectionIndex
  }
}
